import React from 'react'
import { FC } from 'react'
import { PageFooterStyle } from './styled'

interface PageFooterProps {
  title: string
}

const PageFooter: FC<PageFooterProps> = ({ title }) => {
  return (
    <PageFooterStyle>
      <h1>Footer</h1>
      <p>{title}</p>
    </PageFooterStyle>
  )
}

export default PageFooter
